import { useLang } from "@/lang";
import { Reveal, Eyebrow } from "@/components/Reveal";

const Partners = () => {
  const { t } = useLang();

  return (
    <section data-testid="partners-section" className="border-b border-slate-200 bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <Reveal>
            <Eyebrow>{t.partners.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-display text-xl font-bold tracking-tight text-bei-navy sm:text-2xl">
              {t.partners.title}
            </h2>
          </Reveal>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
          {t.partners.items.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}>
              <span
                data-testid={`partner-${i}`}
                className="inline-block rounded-full border border-slate-200 bg-bei-mist px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-slate-500 transition-all duration-300 hover:-translate-y-0.5 hover:border-bei-brand hover:text-bei-brand sm:px-8"
              >
                {p}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
